import { useRef } from 'react';
import { AbortableFetch, useEventCallback } from '@eas/common-web';
import {
  getRedirectUrl,
  addProviderToUser,
  createUser,
} from './identity-provider-api';
import { IdentityProviderUserData } from './identity-provider-types';

export function useIdentityProvider() {
  const addProviderFetch = useRef<AbortableFetch | null>(null);
  const handleAddProviderToUser = useEventCallback(async (token: string) => {
    if (addProviderFetch.current !== null) {
      addProviderFetch.current.abort();
    }
    addProviderFetch.current = addProviderToUser(token);
    await addProviderFetch.current.raw();
  });

  const registerFetch = useRef<AbortableFetch | null>(null);

  const createUnconfirmedUser = useEventCallback(async (token: string) => {
    if (registerFetch.current !== null) {
      registerFetch.current.abort();
    }

    registerFetch.current = createUser(token);

    const response = await registerFetch.current.json();

    return response as IdentityProviderUserData;
  });

  return {
    redirectUrl: getRedirectUrl,
    handleAddProviderToUser,
    createUnconfirmedUser,
  };
}
